// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c39b5602","453":"6da2138a","918":"388a2be7"}[chunkId] + ".chunk.js";
};